import { chakra, Text, VStack } from '@chakra-ui/react'
import React from 'react'

export const TitleSubtitle = ({
  title,
  subtitle,
  // titleTag = 'h2',
  ...props
}) => {
  return (
    <VStack textAlign="center" {...props}>
      <chakra.h2
        className="px-4 font-bold text-center uppercase title md:px-0 font-heading text-l sm:text-xl"
        sx={{ span: { fontWeight: 'light' } }}
        dangerouslySetInnerHTML={{ __html: title }}  // nosemgrep: typescript.react.security.audit.react-dangerouslysetinnerhtml.react-dangerouslysetinnerhtml -- WordPress CMS-authored content via WPGraphQL, rendered at Gatsby build time, not runtime user input
      />
      {subtitle && (
        <Text
          as="p"
          className="text-center subtitle"
          maxW={800}
          dangerouslySetInnerHTML={{ __html: subtitle }}  // nosemgrep: typescript.react.security.audit.react-dangerouslysetinnerhtml.react-dangerouslysetinnerhtml -- WordPress CMS-authored content via WPGraphQL, rendered at Gatsby build time, not runtime user input
        />
      )}
    </VStack>
  )
}
